// import InsightsGeneratePagination from "./insightsGeneratePagination";

export default function() {
  // helper function to loop over nodeLists to add event handlers
  function addEventListenerList(list, event, fn) {
    for (let i = 0, len = list.length; i < len; i += 1) {
      list[i].addEventListener(event, fn, false);
    }
  }

  // get the posts matching current filter
  const allPosts = document.querySelectorAll(".b-allInsights__item");
  // console.log("current set of shown posts is");
  // console.log(allPosts);
  // get filter buttons
  const paginationButtons = document.querySelectorAll(".js-insightsPagination");

  function applyPagination(pageNo) {
    // hide all posts
    allPosts.forEach(item => {
      const x = item;
      x.style.display = "none";
    });
    // get the posts with page number
    const postsToShow = document.querySelectorAll(
      `.b-allInsights__item:not(.isHidden)[data-pageno='${pageNo}']`
    );
    // console.log("posts to show");
    // console.log(postsToShow);

    // show those for current page
    postsToShow.forEach(item => {
      const x = item;
      x.style.display = "block";
    });
  }

  // if there are pagination buttons
  if (paginationButtons.length > 0) {
    // add the active class to the first one
    document.querySelector(".js-insightsPagination").classList.add("is-active");
    // get the page number from the active one
    const currentPagePagination = document.querySelector(
      ".js-insightsPagination.is-active"
    );
    const currentPageNo = currentPagePagination.dataset.page;
    // console.log(currentPageNo);
    applyPagination(currentPageNo);
  }

  function handlePaginationClick(e) {
    e.preventDefault();

    // get previously active button
    const previousButton = document.querySelector(
      ".js-insightsPagination.is-active"
    );

    // get the page number
    const pageNo = this.dataset.page;
    // console.log(pageNo);

    applyPagination(pageNo);

    // apply classes to navigation
    previousButton.classList.remove("is-active");
    this.classList.add("is-active");
  }

  addEventListenerList(paginationButtons, "click", handlePaginationClick);
}



// WEBPACK FOOTER //
// ./assets/scripts/modules/insightsPagination.js